export const API_KEY = '&appid=8207e11f4329e85d03fa5d3bd7c9f606';
// export const API_KEY = '&units=metric&lang=zh_cn&appid=8207e11f4329e85d03fa5d3bd7c9f606';
export const ZIP_BASE = 'https://api.openweathermap.org/data/2.5/weather?zip=';
export const CITY_BASE = 'https://api.openweathermap.org/data/2.5/weather?q=';
export const FIVE_DAY_FORECAST_BASE = 'https://api.openweathermap.org/data/2.5/forecast?zip=';
